module.exports = __webpack_public_path__ + "static/media/header.5fdf51b6.png";